import React, { Component } from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { Dialog } from "primereact/dialog";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import api from "../service/ApiService";
import { getUserProfileUrl, baseUrl } from "../service/ApiUrls";
import { ModuleNameEnum, UploadActionEnum } from "../Enums";
import Loader from "../components/Loader";
import SuccessDialog from "../components/SuccessDialog";
import ImgUpload from "../components/ImgUpload";

const userImg = require("../assets/user_profile.png");

class NewUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullName: "",
      email: "",
      username: "",
      phoneNo: "",
      nid: "",
      divisionId: null,
      roleId: null,
      opt: null,
      selectedProfile: null,
      selectedGroup: null,
      divisionList: [],
      roleList: [],
      profileList: [],
      groupList: [],
      imagePreviewUrl: userImg,
      profilePictureTempId: null,
      isLoading: false,
      isSuccess: false,
      errors: {},
      isEdit:
        props.history.location.state !== undefined &&
        props.history.location.state.rowData !== undefined,
    };
    this.dropOptionChange = this.dropOptionChange.bind(this);
  }

  componentDidMount() {
    this.fetchDivisions();
    if (this.state.isEdit) {
      this.webcallgeteditprofile();
    } else {
      const isAdmin = this.props.history.location.state?.admin === true;
      this.webcallGetForProfile({ type: isAdmin ? 0 : 1 });

      // For new Admin entries, ensure divisionId starts as null
      if (isAdmin) {
        this.setState({ divisionId: null });
      }
    }
  }

  // --- API CALLS ---

  fetchDivisions = () => {
    api.get(`${baseUrl}/division-list/all`).then((res) => {
      if (res.data && res.data.data) {
        this.setState({ divisionList: res.data.data });
      }
    }).catch(err => console.error("Division fetch error:", err));
  };

  webcallGetForProfile = ({ type = 0 } = {}) => {
    this.setState({ isLoading: true });
    api.get(baseUrl + "/user-list/add", { params: { type: type } })
      .then((res) => {
        if (res.data.result.isError === false) {
          const { roleId, roleList, profileList, groupList } = res.data.data;
          const selectedopt = roleList.find((e) => e.id === roleId);

          this.setState({
            roleList,
            profileList,
            groupList,
            opt: selectedopt,
            roleId: roleId,
            isLoading: false
          });
        } else {
          this.setState({ isLoading: false });
          this.showError(res.data.result.errorMsg);
        }
      }).catch(() => this.setState({ isLoading: false }));
  };

  webcallgeteditprofile = () => {
    this.setState({ isLoading: true });
    let id = this.props.history.location.state.rowData.id;

    api.get(baseUrl + "/user-list/" + id).then((res) => {
      if (res.data.result.isError === false) {
        const { content, roleList, profileList, groupList } = res.data.data;
        const selectedopt = roleList.find((e) => e.id === content.roleId);

        this.setState({
          ...content,
          roleList,
          profileList,
          groupList,
          opt: selectedopt,
          selectedProfile: content.deviceProfiles,
          selectedGroup: content.deviceGroups,
          imagePreviewUrl: content.profilePictureBase64St
            ? "data:image/jpeg;base64," + content.profilePictureBase64St
            : userImg,
          isLoading: false
        });
      } else {
        this.setState({ isLoading: false });
        this.showError(res.data.result.errorMsg);
      }
    }).catch(() => this.setState({ isLoading: false }));
  };

  webPhotoupload = (file) => {
    const formData = new FormData();
    formData.append("uploadActionType", UploadActionEnum.IMAGEUPLOAD);
    formData.append("moduleName", ModuleNameEnum.USERPROFILE);
    formData.append("file", file);

    api.post(baseUrl + "/uploads", formData).then((res) => {
      if (res.data.result.isError === false) {
        this.setState({ profilePictureTempId: res.data.data.fileTempId });
      }
    });
  };

  photoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      this.setState({ imagePreviewUrl: reader.result }, () => {
        this.webPhotoupload(file);
      });
    };
    reader.readAsDataURL(file);
  };

  // --- HANDLERS ---

  dropOptionChange(e) {
    this.setState({ opt: e.value, roleId: e.value.id });
  }

  changeHandler = (e) => {
    const { id, value } = e.target;
    this.setState(prev => ({
      [id]: value,
      errors: { ...prev.errors, [id]: "" }
    }));
  };

  validateForm = () => {
    let errors = {};
    let isValid = true;
    const isAdminContext = this.props.history.location.state?.admin === true;

    if (!this.state.fullName?.trim()) { errors.fullName = "Full name is required"; isValid = false; }
    if (!this.state.username?.trim()) { errors.username = "Username is required"; isValid = false; }
    if (!this.state.opt) { errors.role = "Role is required"; isValid = false; }

    // Division is ONLY mandatory if NOT an admin
    if (!isAdminContext && !this.state.divisionId) {
      errors.divisionId = "Division is required";
      isValid = false;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!this.state.email?.trim()) {
      errors.email = "Email is required";
      isValid = false;
    } else if (!emailPattern.test(this.state.email)) {
      errors.email = "Invalid email format";
      isValid = false;
    }

    this.setState({ errors });
    return isValid;
  };

  handleSubmit = () => {
    if (!this.validateForm()) return;

    this.setState({ isLoading: true });
    const dataToSend = {
      fullName: this.state.fullName,
      email: this.state.email,
      username: this.state.username,
      phoneNo: this.state.phoneNo,
      nid: this.state.nid,
      roleId: this.state.roleId,
      divisionId: this.state.divisionId, // Will pass null if admin and nothing selected
      deviceProfiles: this.state.selectedProfile,
      deviceGroups: this.state.selectedGroup,
      accType: this.props.history.location.state?.admin === true ? 0 : 1,
      profilePictureTempId: this.state.profilePictureTempId,
    };

    if (this.state.isEdit) {
      dataToSend.id = this.props.history.location.state.rowData.id;
    }

    const url = this.state.isEdit ? `${baseUrl}/user-list/${dataToSend.id}` : `${baseUrl}/user-list/add`;
    const method = this.state.isEdit ? "put" : "post";

    api[method](url, dataToSend).then((res) => {
      this.setState({ isLoading: false });
      if (res.data.result.isError === false) {
        this.setState({ isSuccess: true });
        setTimeout(() => this.props.history.push("/user-management"), 1500);
      } else {
        this.showError(res.data.result.errorMsg);
      }
    }).catch(() => this.setState({ isLoading: false }));
  };

  showError = (msg) => {
    confirmAlert({
      title: "Error",
      message: <p>{msg}</p>,
      buttons: [{ label: "Ok" }]
    });
  };

  render() {
    const { isEdit, errors, opt } = this.state;
    const isAdminContext = this.props.history.location.state?.admin === true;

    const items = [
      { label: "Dashboard", url: "dashboard" },
      { label: "Home Ground", url: "home-ground" },
      { label: "User Management", url: "user-management" },
      { label: isEdit ? "Edit User" : "New User" },
    ];

    return (
      <div className="p-grid p-fluid" style={{ padding: '1rem' }}>
        <div className="p-col-12">
          <BreadCrumb model={items} home={{ icon: "pi pi-home", url: "dashboard" }} />
        </div>

        {/* Dialogs */}
        <Dialog visible={this.state.isSuccess} modal onHide={() => this.setState({ isSuccess: false })} style={{ width: "25vw" }}>
          <SuccessDialog successMessage="User Saved Successfully" />
        </Dialog>

        <Dialog visible={this.state.isLoading} modal closable={false} showHeader={false} style={{ width: "20vw" }}>
          <Loader />
        </Dialog>

        <div className="p-col-12 mt-3">
          <div className="card shadow-sm" style={{ background: '#fff', borderRadius: '15px', padding: '2rem' }}>
            <div className="p-grid">

              {/* Left Profile Section */}
              <div className="p-col-12 p-md-3 text-center border-right">
                <ImgUpload onChange={this.photoUpload} src={this.state.imagePreviewUrl} />
                <p className="mt-2 text-muted font-weight-bold">Profile Picture</p>
              </div>

              {/* Right Form Section */}
              <div className="p-col-12 p-md-9">
                <div className="p-grid">

                  {/* Top Row: Division and Role */}
                  <div className="p-col-12 p-md-6 mb-3">
                    <label className="font-weight-bold">
                      Division {!isAdminContext && <span className="text-danger">*</span>}
                    </label>
                    <Dropdown
                      value={this.state.divisionId}
                      options={this.state.divisionList}
                      onChange={(e) => this.setState({ divisionId: e.value, errors: { ...errors, divisionId: "" } })}
                      optionLabel="name"
                      optionValue="id"
                      placeholder="Select Division"
                      className={errors.divisionId ? "p-invalid" : ""}
                      showClear={isAdminContext} // Allow admins to clear the selection back to null
                    />
                    {errors.divisionId && <small className="p-error">{errors.divisionId}</small>}
                  </div>

                  <div className="p-col-12 p-md-6 mb-3">
                    <label className="font-weight-bold">Role <span className="text-danger">*</span></label>
                    <Dropdown
                      value={this.state.opt}
                      options={this.state.roleList}
                      onChange={this.dropOptionChange}
                      optionLabel="name"
                      placeholder="Select Role"
                      className={errors.role ? "p-invalid" : ""}
                    />
                  </div>

                  {/* Second Row: Full Name and Username */}
                  <div className="p-col-12 p-md-6 mb-3">
                    <label className="font-weight-bold">Full Name <span className="text-danger">*</span></label>
                    <input className="form-control" id="fullName" value={this.state.fullName || ""}
                      onChange={this.changeHandler} placeholder="Enter Full Name" />
                    {errors.fullName && <small className="text-danger">{errors.fullName}</small>}
                  </div>

                  <div className="p-col-12 p-md-6 mb-3">
                    <label className="font-weight-bold">Username <span className="text-danger">*</span></label>
                    <input className="form-control" id="username" value={this.state.username || ""}
                      onChange={this.changeHandler} disabled={isEdit} placeholder="Enter Username" />
                    {errors.username && <small className="text-danger">{errors.username}</small>}
                  </div>

                  {/* Third Row: Email and Phone */}
                  <div className="p-col-12 p-md-6 mb-3">
                    <label className="font-weight-bold">Email Address <span className="text-danger">*</span></label>
                    <input className="form-control" id="email" value={this.state.email || ""}
                      onChange={this.changeHandler} placeholder="example@mail.com" />
                    {errors.email && <small className="text-danger">{errors.email}</small>}
                  </div>

                  <div className="p-col-12 p-md-6 mb-3">
                    <label className="font-weight-bold">Phone Number</label>
                    <input className="form-control" id="phoneNo" value={this.state.phoneNo || ""}
                      onChange={this.changeHandler} placeholder="01XXX-XXXXXX" />
                  </div>

                  {/* NID Section (Full Width) */}
                  <div className="p-col-12 mb-3">
                    <label className="font-weight-bold">NID</label>
                    <input className="form-control" id="nid" value={this.state.nid || ""}
                      onChange={this.changeHandler} placeholder="Enter NID Number" />
                  </div>

                  {/* Dynamic Fields */}
                  {opt?.responsibleFor === 1 && (
                    <div className="p-col-12 mb-3">
                      <label className="font-weight-bold">Device Profile</label>
                      <MultiSelect value={this.state.selectedProfile} options={this.state.profileList}
                        onChange={(e) => this.setState({ selectedProfile: e.value })} optionLabel="name" filter />
                    </div>
                  )}

                  {opt?.responsibleFor === 2 && (
                    <div className="p-col-12 mb-3">
                      <label className="font-weight-bold">Device Group</label>
                      <MultiSelect value={this.state.selectedGroup} options={this.state.groupList}
                        onChange={(e) => this.setState({ selectedGroup: e.value })} optionLabel="name" filter />
                    </div>
                  )}
                </div>

                {/* Footer Buttons */}
                <div className="p-col-12 mt-4 d-flex justify-content-end">
                  <Button
                    label="Cancel"
                    icon="pi pi-times"
                    className="p-button-danger mr-2"
                    style={{ width: '130px' }}
                    onClick={() => this.props.history.push("/user-management")}
                  />
                  <Button
                    label={isEdit ? "Update" : "Submit"}
                    icon="pi pi-check"
                    className="p-button-primary"
                    onClick={this.handleSubmit}
                    style={{ width: '130px' }}
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NewUsers;